// Sync with functions config/cdn
export default {
  widgetConfigsPath: 'cdn/v0/widget-configs',
  widgetPollingPath: 'cdn/v0/widget-polling',
  widgetWorkbookPath: 'cdn/v0/widget-workbooks'
};